import API from '@services/API';

const AtividadeService = {
  listar: async () => await API.list(`/empresas`),
  listAll: async (params) => await API.filters(`/empresas/all`, params ),
  buscarPorId: async (id) => await API.find(`/empresas`, id),
  adicionar: async (empresa) => await API.add(`/empresas`, empresa),
  editar: async (id, empresa) => await API.edit(`/empresas`, id, empresa),
  excluir: async (id) => await API.remove(`/empresas`, id),

  listarEmpresaColaborador: async (id) => await API.list(`/colaboradores/${id}/empresa`),
  adicionarEmpresaColaborador: async (colaborador) => await API.edit(`/colaboradores/${colaborador.id}/empresa`, colaborador.empresa),
  removerEmpresaColaborador: async (id) => await API.remove(`/colaboradores/${id}/empresa`, ''),
}

export default AtividadeService;
